import React from 'react';

export default props => (
  <div className='filter'>
    <span className='filter-type'>Showing only questions.</span>
    <button className='dismiss-standard' onClick={() => props.onDelete('question')}>Remove</button>
  </div>
)